// extracted by mini-css-extract-plugin
export default {"productGallery":"lF-z","inQuickShop":"mF-z"};